module.exports = __webpack_public_path__ + "img/riohacha.527f701d.png";